/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';
import { dataDogAddWarning } from '../logging/datadog';
import { keycloakConfig } from '../keycloak/keycloak';

const IMAGES_URL = '/images';
const AUDIOS_URL = '/audios';
const CACHE_NAME = 'lantern-cache-v3';

const SERVICE_WORKER =
    process.env.NODE_ENV === 'development'
        ? '/service-worker.js'
        : '/student-assessment/service-worker.js';

export const clearCDNCachedContent = () => {
    caches.open(CACHE_NAME).then(cache => {
        cache.keys().then(cacheKeys => {
            cacheKeys.forEach(request => {
                if (request.url.includes(IMAGES_URL) || request.url.includes(AUDIOS_URL)) {
                    cache.delete(request);
                }
            });
        });
    });

    return Promise.resolve();
};

export const registerServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        try {
            const reg = await navigator.serviceWorker.register(SERVICE_WORKER);
            console.log(`Registration succeeded. Scope is ${reg.scope}`);
            reg.onupdatefound = () => {
                const installingWorker = reg.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            console.log('New content is available; please refresh.');
                        } else {
                            console.log('Content is cached for offline use.');
                        }
                    }
                };
            };
            return reg;
        } catch (error) {
            console.log(`Registration failed with ${error}`);
        }
    } else {
        console.log('Service workers are not supported on this browser.');
    }
    return null;
};

export const getOnlineStatus = async () => {
    const signal = AbortSignal.timeout(5000);
    const baseUrl = keycloakConfig.url.endsWith('/')
        ? keycloakConfig.url
        : `${keycloakConfig.url}/`;
    const keycloakPublicEndpoint = `${baseUrl}realms/${keycloakConfig.realm}/.well-known/openid-configuration`;

    if (!navigator.onLine) {
        datadogRum.addAction('Network status is offline', {
            endpoint: keycloakPublicEndpoint,
            status: 'offline',
            reason: 'navigator.onLine is false',
        });

        return navigator.onLine;
    }

    try {
        const response = await fetch(keycloakPublicEndpoint, {
            method: 'GET',
            cache: 'no-cache',
            signal,
        });

        datadogRum.addAction('Network status is online', {
            endpoint: keycloakPublicEndpoint,
            status: 'online',
            httpStatus: response.status,
        });
        return true;
    } catch (error) {
        dataDogAddWarning('Network status is offline', { error, endpoint: keycloakPublicEndpoint });
        console.warn('Network status is offline', error);
        return false;
    }
};

export class OfflineError extends Error {
    constructor(message) {
        super(message);
        this.name = 'OfflineError';
    }
}
